import { render, staticRenderFns } from "./BatchSettingDialog.vue?vue&type=template&id=284d55bf&scoped=true&"
import script from "./BatchSettingDialog.vue?vue&type=script&setup=true&lang=js&"
export * from "./BatchSettingDialog.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.10.2_babel-core@7.0.0-bridge.0_cache-loader@4.1.0_css-loader@3.6.0_lodash@4.17._qkvgvrmvpkafkn37suro37nope/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "284d55bf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/web_gys_admin_online_docker/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('284d55bf')) {
      api.createRecord('284d55bf', component.options)
    } else {
      api.reload('284d55bf', component.options)
    }
    module.hot.accept("./BatchSettingDialog.vue?vue&type=template&id=284d55bf&scoped=true&", function () {
      api.rerender('284d55bf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/nb/goods/goods/pickCardSet/BatchSettingDialog.vue"
export default component.exports